/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

$(function () {
  // -------------------------------------------------------------------------
  // Original Processes
  // -------------------------------------------------------------------------
  $(document).on('click', '.ajax-cart__toggle', () => window.location.href = theme.cartUrl);

  $(document).on("ajaxSuccess", (event, jqxhr, options, data) => {
    if (options.url.includes("cart") && data.hasOwnProperty("item_count")) {
      var $counter = $("[data-cart-count]");
      $counter
        .addClass("animate-pop")
        .text(data.item_count)
        .on("animationend", () => $counter.removeClass("animate-pop"));
    }
  });

  $("#add-brine-to-cart").click(e => {
    e.preventDefault ? e.preventDefault() : e.returnValue = false;

    fetch('/products/thankful-turkey-brining-kit.js')
      .then(response => response.json())
      .then(product => fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: product.variants[0].id, quantity: 1 }] })
      }))
      .then(() => window.location.reload())
      .catch(() => alert("Sorry!  We couldn't add the brining kit from this page.  Please click the \"more info\" button, and add it to your cart from there!"));
  });
});

/* -----------------------------------------------------------------------------
   Select2 loader + initializers
   - Re-inits on Shopify section events and DOM mutations.
----------------------------------------------------------------------------- */
(function () {
  // -------- Base Config --------
  var SELECTOR_BULK = '.product-form__quantity-bulk-select';
  var SELECTOR_HEAR = '#CartHearAboutUs';
  var MAX_RETRIES = 40;        // ~8s (40 * 200ms)
  var RETRY_EVERY_MS = 200;
  var LOG = false;             // set true to debug

  // Static amounts for bulk quantity select
  var BULK_DATA = [
    { id: 20,   text: "20" },
    { id: 50,   text: "50" },
    { id: 75,   text: "75" },
    { id: 100,  text: "100" },
    { id: 150,  text: "150" },
    { id: 250,  text: "250" },
    { id: 500,  text: "500" },
    { id: 1000, text: "1000" }
  ];

  // -------- Utilities --------
  function log() { if (LOG) console.log.apply(console, arguments); }

  function getjQuery() {
    if (window.jQuery) return window.jQuery;
    if (window.$ && window.$.fn && window.$.fn.jquery) return window.$;
    return null;
  }

  function hasSelect2($) {
    return $ && $.fn && typeof $.fn.select2 === 'function';
  }

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.body.appendChild(s);
    });
  }

  function formatCurrency(value) {
    try {
      return new Intl.NumberFormat(Shopify.locale, {
        style: 'currency',
        currency: Shopify.currency.active
      }).format(value);
    } catch (e) {
      return '$' + Number(value).toLocaleString();
    }
  }

  function bulkRenderer(item) {
    if (!item.id) return item.text;
    var $ = getjQuery();
    var $c = $('<div>').addClass('bulk-option');
    var $b = $('<b>').text(formatCurrency(item.id * 1));
    $c.append($b);
    return $c;
  }

  // -------- Initializers --------
function initBulkSelect2(root) {
  var $ = getjQuery();
  if (!hasSelect2($)) return false;

  var $root = root ? $(root) : $(document);
  var $els = $root.find(SELECTOR_BULK);
  if (!$els.length) return false;

  $els.each(function () {
    var $el = $(this);

    // Ensure tag = select
    if ($el.prop('tagName') !== 'SELECT') return;

    // --- Duplicate guard ---
    if ($el.hasClass('select2-hidden-accessible')) return;              // already transformed
    if ($el.attr('data-mfinited') === '1') return;                      // Data marker
    if ($el.data('mf_init_in_progress')) return;                        // Process lock

    // Enable process lock
    $el.data('mf_init_in_progress', true);

    // If some prior init left a container behind, remove it
    var $next = $el.next('.select2');
    if ($next.length) $next.remove();

    // Ensure options exist (in case DOM hasn’t populated yet)
    if (!$el.find('option').length) {
      BULK_DATA.forEach(function (o) {
        $el.append($('<option>', { value: o.id, text: o.text }));
      });
    }

    // Remove old handlers
    $el.off('.mf');

    $el.select2({
      data: BULK_DATA,
      createTag: function (query) {
        if (/^\d+$/.test(query.term) && parseInt(query.term, 10) > 19) {
          return { id: parseInt(query.term, 10), text: query.term };
        }
        return null;
      },
      language: { noResults: function () { return 'Please enter a valid number'; } },
      minimumInputLength: 0,
      tags: true,
      templateResult: bulkRenderer,
      templateSelection: bulkRenderer,
      width: '100%'
    })
    .off('select2:open.mf')
    .on('select2:open.mf', function () {
      $("input.select2-search__field[type='search']").attr('placeholder', 'Please enter your donation');
    });

    // Mark as initialized & allow for processing
    $el.attr('data-mfinited', '1');
    $el.data('mf_init_in_progress', false);
  });

  return true;
}

function initHearAboutUs(root) {
  var $ = getjQuery();
  if (!hasSelect2($)) return false;

  var $root = root ? $(root) : $(document);
  var $el = $root.find(SELECTOR_HEAR);
  if (!$el.length) return false;

  if ($el.prop('tagName') !== 'SELECT') return;

  // Prevent duplicates
  if ($el.hasClass('select2-hidden-accessible')) return;
  if ($el.attr('data-mfinited') === '1') return;
  if ($el.data('mf_init_in_progress')) return;

  $el.data('mf_init_in_progress', true);

  var $next = $el.next('.select2');
  if ($next.length) $next.remove();

  $el.off('.mf');

  $el.select2({
    allowClear: true,
    minimumInputLength: 0,
    placeholder: 'How did you hear about us? (optional)',
    tags: true,
    width: '100%'
  })
  .off('select2:open.mf')
  .on('select2:open.mf', function () {
    $("input.select2-search__field[type='search']").attr('placeholder', 'Enter your own response here');
  });

  $el.attr('data-mfinited', '1');
  $el.data('mf_init_in_progress', false);

  return true;
}

  function initAll(root) {
    var initedAny = false;
    initedAny = initBulkSelect2(root) || initedAny;
    initedAny = initHearAboutUs(root) || initedAny;
    return initedAny;
  }

  // -------- wait for jQuery + Select2 + elements --------
  function boot(attempt) {
    attempt = attempt || 0;
    var $ = getjQuery();

    if (!$) {
      if (attempt < MAX_RETRIES) return setTimeout(function(){ boot(attempt+1); }, RETRY_EVERY_MS);
      return;
    }

    // Load Select2 if missing
    if (!hasSelect2($)) {
      loadScript('https://cdn.jsdelivr.net/npm/select2@4.1.0-rc.0/dist/js/select2.min.js')
        .then(function(){ setTimeout(boot, 50, attempt+1); })
        .catch(function(){ console.warn('Failed to load Select2'); });
      return;
    }

    // Try to init; if selects don't exist yet, retry
    if (!initAll()) {
      if (attempt < MAX_RETRIES) setTimeout(function(){ boot(attempt+1); }, RETRY_EVERY_MS);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);

  // Re-init on Shopify section/block change
  [
    'shopify:section:load',
    'shopify:section:select',
    'shopify:section:deselect',
    'shopify:section:reorder',
    'shopify:block:select',
    'shopify:block:deselect'
  ].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      initAll(e && e.target ? e.target : document);
    });
  });

  // Re-init on DOM mutations (reprocessed sections)
  var mo = new MutationObserver(function (mutations) {
    var needs = false;
    mutations.forEach(function (m) {
      if (needs) return;
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType !== 1) continue;
        if (n.matches?.(SELECTOR_BULK) || n.querySelector?.(SELECTOR_BULK) ||
            n.matches?.(SELECTOR_HEAR) || n.querySelector?.(SELECTOR_HEAR)) {
          needs = true;
          break;
        }
      }
    });
    if (needs)  initAll();
  });
  mo.observe(document.documentElement, { childList: true, subtree: true });
})();
